import type { FC } from "react"
import React from "react"
import { FormErrorMessage, Icon, Text } from "@chakra-ui/react"
import capitalize from "lodash.capitalize"

import RedCircleX from "ui/components/icons/RedCircleX"

type NewProposalFormErrorProps = {
  error?: string
}

const NewProposalFormError: FC<NewProposalFormErrorProps> = ({ error }) => {
  return (
    <FormErrorMessage color="purple.900" mt={1.5}>
      <Icon as={RedCircleX} />
      <Text ml={1}>{capitalize(error)}</Text>
    </FormErrorMessage>
  )
}

export default NewProposalFormError
